import useUser from '@cobliteam/hooks/src/useEntity/useUser';
import NotificationCardFrame from '../core/NotificationCardFrame';
import type { NotificationCardRender } from '../core/NotificationType';
import { getCardTypes } from '../registry';

// Um slot por tipo de card: chama o controller do tipo (hook) e, quando há algo a mostrar, monta a moldura
// flutuante genérica com o corpo do tipo. O controller vem como prop (`use`-prefixed) — chamado uma vez,
// no topo, sem condicional, então as regras dos hooks valem.
const NotificationCardSlot = ({ useController }: { useController: () => NotificationCardRender | null }) => {
  const render = useController();
  if (!render) return null;

  return (
    <NotificationCardFrame isExiting={render.isExiting} isRightPanelHidden={render.isRightPanelHidden} onTransitionEnd={render.onTransitionEnd}>
      {render.body}
    </NotificationCardFrame>
  );
};

/**
 * Surface genérica do card flutuante: renderiza um slot por tipo registrado que tem `surfaces.card`.
 * Master gate = sessão presente (os controllers leem a sessão); cada tipo gateia internamente por flag +
 * página. O feed do Knock saiu (AI-450) — sem mais dependência de provider/env do Knock.
 */
const NotificationFloatingCard = () => {
  const { getSession } = useUser();
  const userId = getSession()?.user?.id;

  if (!userId) return null;

  return (
    <>
      {getCardTypes().map((type) => (
        <NotificationCardSlot key={type.key} useController={type.useCardController!} />
      ))}
    </>
  );
};

export default NotificationFloatingCard;
